import { useState } from 'react'
import { useMenuDataJson } from '../../hooks/useMenuDataJson'
import { formatPrice } from '../../data/menuData'
import LazyImage from '../LazyImage/LazyImage'
import './MenuSection.css'

const PEDIX_HOME_URL = 'https://pedix.app/mister-burger/'

const MenuSection = () => {
  const [activeCategory, setActiveCategory] = useState('burger')
  const { data, status } = useMenuDataJson()
  const items = data?.menuItems || []
  
  const getItemsByCategory = (category) => {
    return items.filter(item => item.category === category)
  }

  const getCategoryCount = (category) => {
    return getItemsByCategory(category).length
  }

  const openPedixUrl = (url) => {
    window.open(url || PEDIX_HOME_URL, '_blank', 'noopener,noreferrer')
  }

  const getCategoryUrl = (categoryId) => {
    return categories.find(category => category.id === categoryId)?.pedixCategoryUrl
  }

  const handleOrderClick = () => {
    openPedixUrl(PEDIX_HOME_URL)
  }

  const handleCategoryOrderClick = (categoryId) => {
    openPedixUrl(getCategoryUrl(categoryId))
  }

  if (status === 'loading' && !data) {
    return (
      <section className="menu-section" id="menu">
        <div className="container"><p>Cargando menú…</p></div>
      </section>
    )
  }

  const categories = data?.menuCategories || []
  const activeCategoryData = categories.find(category => category.id === activeCategory) || categories[0]
  const activeItems = activeCategoryData ? getItemsByCategory(activeCategoryData.id) : []
  const spotlightItem = activeItems[0]
  const hasWideFeaturedItem = activeItems.length === 1 || activeItems.length % 2 === 1

  return (
    <section className="menu-section" id="menu">
      <div className="container">
        <div className="menu-intro">
          <div>
            <span className="menu-eyebrow">Mota Botello 320</span>
            <h3>Nuestro Menú Completo</h3>
            <p>
              Servimos hamburguesas en Catamarca con identidad Mister: burgers,
              lomos jugosos, wraps frescos y ensaladas preparadas al momento.
              Hacé tu pedido online para delivery o pick up.
            </p>
          </div>
          <button className="btn btn-primary menu-order-button" onClick={handleOrderClick}>
            HACER PEDIDO ONLINE
          </button>
        </div>

        <div className="menu-app-shell">
          <nav className="menu-category-rail" aria-label="Categorías del menú">
            {categories.map(category => (
              <button
                key={category.id}
                type="button"
                className={`menu-category-button ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
                aria-pressed={activeCategory === category.id}
              >
                <span className="menu-category-name">
                  <span className="menu-category-icon" aria-hidden="true">{category.icon}</span>
                  {category.name}
                </span>
                <span className="menu-category-count">{getCategoryCount(category.id)}</span>
              </button>
            ))}
          </nav>

          <div className="menu-product-feed" aria-live="polite">
            <div className="category-header">
              <div>
                <span className="category-kicker">Seleccion actual</span>
                <h4>
                  <span aria-hidden="true">{activeCategoryData?.icon}</span> {activeCategoryData?.name}
                </h4>
              </div>
              <span className="item-count">
                {activeItems.length} opciones
              </span>
            </div>

            <div className="menu-items-grid">
              {activeItems.map((item, index) => (
                <article key={item.id} className={`menu-item ${hasWideFeaturedItem && index === 0 ? 'featured' : ''}`}>
                  <div className="menu-item-image">
                    <LazyImage
                      src={item.image}
                      fallbackSrc={item.imageUrl}
                      alt={item.name}
                      className="menu-product-photo"
                    />
                  </div>
                  <div className="menu-item-content">
                    <div className="menu-item-info">
                      <h5>{item.name}</h5>
                      <p>{item.description}</p>
                    </div>
                    <div className="menu-item-side">
                      <div className="menu-item-price">
                        {formatPrice(item.price)}
                      </div>
                      <button
                        type="button"
                        className="menu-item-order-button"
                        onClick={() => handleCategoryOrderClick(item.category)}
                        aria-label={`Pedir ${item.name} en Pedix`}
                      >
                        Pedir
                      </button>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>

          {spotlightItem && (
            <aside className="menu-spotlight" aria-label="Producto destacado">
              <div className="spotlight-copy">
                <span>Especial destacado</span>
                <h4>{spotlightItem.name}</h4>
              </div>
              <div className="spotlight-image">
                <LazyImage
                  src={spotlightItem.image}
                  fallbackSrc={spotlightItem.imageUrl}
                  alt={spotlightItem.name}
                  className="spotlight-photo"
                />
              </div>
              <div className="spotlight-footer">
                <span className="spotlight-price">
                  {formatPrice(spotlightItem.price)}
                </span>
                <button
                  type="button"
                  className="spotlight-button"
                  onClick={() => handleCategoryOrderClick(spotlightItem.category)}
                >
                  Pedir ahora
                </button>
              </div>
            </aside>
          )}
        </div>
      </div>
    </section>
  )
}

export default MenuSection
